import { render, staticRenderFns } from "./NameCheckResults.vue?vue&type=template&id=00337b55&scoped=true&"
import script from "./NameCheckResults.vue?vue&type=script&lang=js&"
export * from "./NameCheckResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00337b55",
  null
  
)

export default component.exports